export default __webpack_public_path__ + "static/media/companies.c4ed75d5.png";